
export default {
  auth: false,
  layout: 'login',
  middleware: ['isUser'],

  head () {
    return {
      titleTemplate: this.$t('register.do') + ' - %s',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.register')
        }
      ],
    }
  },
  data () {
    return {
      backendErrors: {},
      success: false,
      socialLoginError: false,
      login: {
        first_name: '',
        sex: '',
        email: '',
        password: '',
        looking_for: [],
        password_confirmation: '',
        free_month: false,
        privacy_policy_accepted: false,
        source: '',
        first_page_visited: '',
        lang: null
      },
      loader: false,
      loginGoogleUrl: process.env.BACKEND_URL + '/api/login/google',
    }
  },

  mounted () {
    if (
      this.$route.query.free_month == 'true' ||
      this.$route.query.free_month == '1'
    ) {
      this.setCookie('free-month', 'yes', 24 * 60)
      this.login.free_month = 1
    }

    if (this.getCookie('free-month')) {
      this.login.free_month = 1
    }

    if (this.$route.query.social_error == 'true') {
      this.socialLoginError = true
    }

    if (this.$route.query.landing_ver === '1.0') {
      this.$buefy.toast.open({
        message: 'Jesteś już bardzo blisko!',
        type: 'is-success'
      })

      this.login.sex = this.$route.query.sex

      this.login.looking_for = [this.$route.query.looking_for]
    }
  },
  methods: {
    async register () {
      const attribution = this.$consent.attribution()
      this.login.source = attribution.source
      this.login.first_page_visited = attribution.first_page_visited
      this.loader = true
      this.backendErrors = {}
      this.login.lang = this.$i18n.locale

      try {
        this.login.password_confirmation = this.login.password
        const response = await this.$axios.post('/api/register', this.login)
        window.location.replace(this.localePath('/social-login?temp_login_key=' + response.data.temp_login_key))
      } catch (e) {
        this.$sentry.captureException(e)

        if (e.response && e.response.status === 422) {
          if (e.response.data.errors) {
            this.backendErrors = e.response.data.errors
          } else {
            this.backendErrors = { message: [e.response.data.message] }
          }
        } else {
          this.$sentry.captureException(e)

          this.$buefy.toast.open({
            message: this.$t('something_wrong'),
            type: 'is-danger'
          })
        }
      }

      this.loader = false
    }
  }
}
